interface StoreHours {
  dayOfWeek: number; // 1 (Monday) - 7 (Sunday)
  from1?: string;
  to1?: string;
  closed?: boolean;
}

interface FormattedHours {
  dayName: string;
  hours: string;
}

const convertTo12HrFormat = (time?: string): string => {
  if (!time) {
    return "Closed";
  }
  const [hour, minute] = time.split(":");
  const h = parseInt(hour, 10);
  const m = parseInt(minute, 10);
  const amPm = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 || 12; // Convert hour to 12-hour format
  return `${h12}:${m.toString().padStart(2, "0")} ${amPm}`;
};

const formatStoreHours = (hoursDataFromApi: StoreHours[]): FormattedHours[] => {
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return dayNames.map((dayName, index) => {
    // Convert index to match 1 (Monday) - 7 (Sunday), as per the API
    const dayOfWeek = index === 0 ? 7 : index;
    const hoursForDay = hoursDataFromApi.find(
      (day) => day.dayOfWeek === dayOfWeek
    );

    if (hoursForDay?.closed) {
      return { dayName, hours: "Closed" };
    } else if (hoursForDay?.from1 && hoursForDay?.to1) {
      return {
        dayName,
        hours: `${convertTo12HrFormat(
          hoursForDay.from1
        )} - ${convertTo12HrFormat(hoursForDay.to1)}`,
      };
    } else {
      return { dayName, hours: "Closed" }; // Default to "Closed" if hours are missing
    }
  });
};

export default formatStoreHours;
